import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TenantImageEnum, useAssetsContext } from 'summon-ui'
import { useGqlQuery } from '@api/gql/gqlServices'
import { TENANT_CONFIG } from '@config'
import { GetCategoryByIdQuery, GetCategoryByIdDocument } from '@generated/generates'

const isCustomQuestBgsEnabled = TENANT_CONFIG.features.enableQuestPageCustomBgImg

const isQuestsPage = (pathname: string) => {
  return pathname === '/quests'
}

const isQuestPage = (pathname: string) => {
  return /^\/quests\/[a-zA-Z0-9_-]+$/.test(pathname)
}
const isLootdropPage = (pathname: string) => {
  return pathname === '/lootdrop'
}
const isLootdropPageDetails = (pathname: string) => {
  return pathname.match(/.lootdrop.*/)
}
const getQuestId = (pathname: string) => {
  return pathname.split('/')[2]
}

const useCalculateBg = () => {
  const { getTenantImage } = useAssetsContext()
  const homeBgImg = getTenantImage(TenantImageEnum.HomeBg)
  const [bg, setBg] = useState<string | undefined>(undefined)
  const { pathname } = useLocation()
  const { data: categoryData, isLoading: isCategoryLoading } = useGqlQuery<GetCategoryByIdQuery>(
    GetCategoryByIdDocument,
    {
      categoryId: getQuestId(pathname)
    },
    {
      enabled: isQuestPage(pathname)
    }
  )

  useEffect(() => {
    if (isCustomQuestBgsEnabled) {
      if (isQuestsPage(pathname)) {
        setBg(`${TENANT_CONFIG.assetsPrefix}/quests/default.jpg`)
      } else if (isQuestPage(pathname) && !isCategoryLoading) {
        const bg = categoryData?.category?.backgroundUrl || `${TENANT_CONFIG.assetsPrefix}/quests/default.jpg`
        setBg(bg)
      } else if (isLootdropPage(pathname)) {
        setBg(`/images/lootdrops-bg.jpg`)
      } else if (isLootdropPageDetails(pathname)) {
        setBg(`/images/lootdrops-details-bg.jpg`)
      } else {
        setBg(homeBgImg as string)
      }
    } else {
      setBg(homeBgImg as string)
    }
  }, [pathname, isCategoryLoading, isCustomQuestBgsEnabled])

  return bg
}
export default useCalculateBg
